/* AMESHI v38 — progressively enhanced responsive carousel controls. Native touch swipe always works. */
(() => {
  const pad = n => String(n).padStart(2, '0');
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initialise(root = document) {
    const rails = root.querySelectorAll('[data-ameshi-rail]');
    rails.forEach(rail => {
      if (rail.dataset.ameshiReady === '1') return;
      rail.dataset.ameshiReady = '1';

      const panel = rail.closest('.fgt-panel') || rail.closest('.featured-grid-section');
      const controls = panel && panel.querySelector('[data-ameshi-controls]');
      if (!controls) return;

      const cards = [...rail.querySelectorAll('.product-card, .ameshi-more-slide')];
      if (cards.length < 2) { controls.hidden = true; return; }

      const prev = controls.querySelector('[data-ameshi-prev]');
      const next = controls.querySelector('[data-ameshi-next]');
      const current = controls.querySelector('[data-ameshi-current]');
      const total = controls.querySelector('[data-ameshi-total]');
      const progress = controls.querySelector('[data-ameshi-progress]');
      if (total) total.textContent = pad(cards.length);
      let currentIndex = 0;
      let frame = 0;

      const leftOf = card => card.getBoundingClientRect().left - cards[0].getBoundingClientRect().left + rail.scrollLeft;

      const refresh = () => {
        const start = rail.getBoundingClientRect().left + (parseFloat(getComputedStyle(rail).paddingLeft) || 0);
        let nearest = 0;
        let gap = Infinity;
        cards.forEach((card, index) => {
          const diff = Math.abs(card.getBoundingClientRect().left - start);
          if (diff < gap) { gap = diff; nearest = index; }
        });
        currentIndex = nearest;
        if (current) current.textContent = pad(nearest + 1);
        if (progress) progress.style.width = ((nearest + 1) / cards.length * 100) + '%';
        if (prev) prev.disabled = nearest === 0;
        if (next) next.disabled = nearest === cards.length - 1;
      };

      const go = index => {
        const i = Math.max(0, Math.min(cards.length - 1, index));
        rail.scrollTo({
          left: leftOf(cards[i]),
          behavior: reduced() ? 'instant' : 'smooth'
        });
      };
      if (prev) prev.addEventListener('click', () => go(currentIndex - 1));
      if (next) next.addEventListener('click', () => go(currentIndex + 1));

      rail.setAttribute('tabindex', '0');
      rail.setAttribute('role', 'region');
      rail.setAttribute('aria-roledescription', 'carousel');
      rail.setAttribute('aria-label', 'Swipe to explore products');

      rail.addEventListener('keydown', event => {
        if (event.target.closest('a,button,input,select')) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); go(currentIndex + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(currentIndex - 1); }
      });
      rail.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; refresh(); });
      }, { passive:true });
      window.addEventListener('resize', refresh, { passive:true });
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once:true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

/* AMESHI: desktop four-card cinematographic rails, keyboard + arrow buttons. */
(() => {
  const reduce = () => window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  function initialize(root=document){
    root.querySelectorAll('[data-ameshi-desktop-rail]').forEach(rail => {
      if(rail.dataset.desktopReady==='true')return;
      rail.dataset.desktopReady='true';
      const panel=rail.closest('[data-fgt-panel]');
      const nav=panel?.querySelector('[data-featured-nav]');
      if(!nav)return;
      const prev=nav.querySelector('[data-featured-prev]');
      const next=nav.querySelector('[data-featured-next]');
      const cards=[...rail.querySelectorAll(':scope > .fgt-item, :scope > .ameshi-more-slide')];
      if(cards.length<5){nav.hidden=true;return;}
      const scrollTarget = (card) => card.getBoundingClientRect().left-rail.getBoundingClientRect().left+rail.scrollLeft;
      let current=0;
      let frame=0;
      const desktop=()=>window.matchMedia('(min-width:990px)').matches;
      function refresh(){
        if(!desktop())return;
        const left=rail.getBoundingClientRect().left;
        const max=rail.scrollWidth-rail.clientWidth;
        let nearest=0,distance=Infinity;
        cards.forEach((card,i)=>{const d=Math.abs(card.getBoundingClientRect().left-left);if(d<distance){distance=d;nearest=i;}});
        current=nearest;
        prev.disabled=rail.scrollLeft<=4;
        next.disabled=rail.scrollLeft>=max-4;
      }
      function go(delta){
        const viewportStep=Math.max(1,cards[1].offsetWidth+parseFloat(getComputedStyle(rail).columnGap||getComputedStyle(rail).gap||0));
        const target=Math.max(0,Math.min(rail.scrollWidth-rail.clientWidth,rail.scrollLeft+delta*viewportStep));
        rail.scrollTo({left:target,behavior:reduce()?'auto':'smooth'});
      }
      prev.addEventListener('click',()=>go(-1));
      next.addEventListener('click',()=>go(1));
      rail.setAttribute('tabindex','0');
      rail.setAttribute('aria-roledescription','carousel');
      rail.addEventListener('keydown',e=>{
        if(!desktop()||e.target.closest('a,button,input'))return;
        if(e.key==='ArrowRight'){e.preventDefault();go(1);}
        if(e.key==='ArrowLeft'){e.preventDefault();go(-1);}
      });
      rail.addEventListener('scroll',()=>{
        if(frame)return;
        frame=requestAnimationFrame(()=>{frame=0;refresh();});
      },{passive:true});
      window.addEventListener('resize',refresh,{passive:true});
      refresh();
    });
    root.querySelectorAll('[data-ameshi-localize]').forEach(control=>{
      if(control.dataset.bound==='true')return;
      control.dataset.bound='true';
      const dropdowns=[...control.querySelectorAll('details')];
      dropdowns.forEach(item=>item.addEventListener('toggle',()=>{
        if(item.open)dropdowns.filter(o=>o!==item).forEach(o=>o.open=false);
      }));
    });
  }
  document.addEventListener('click',event=>{
    document.querySelectorAll('[data-ameshi-localize] details[open]').forEach(d=>{
      if(!d.contains(event.target))d.open=false;
    });
  });
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll('[data-ameshi-localize] details[open]').forEach(d=>d.open=false);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());
  else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
